<div class="cm-custom-material-button" (click)="chooseMaterialForInput()">
    <cm-button>
        <ng-container cm-left-icon>
            <i class="far fa-folder-open"></i>
        </ng-container>
        <ng-container cm-text> {{ $materialInfo().props.value?.parameters?.name ?? "Choose a material" }}</ng-container>
    </cm-button>
</div>
